/* ============================================
   ET - Bestsellers — filter tabs that swap the visible product slider
   client-side (no reload). Each panel is its own SwiperJS carousel,
   built lazily the first time its tab is shown.
   ============================================ */
(function () {
  'use strict';

  var SEL = '[data-section-type="et-bestsellers"]';

  function initSection(section) {
    if (section.__etBsInit) return;
    section.__etBsInit = true;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-et-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-et-panel]'));
    var viewMores = Array.prototype.slice.call(section.querySelectorAll('[data-et-view-more]'));
    if (!tabs.length || !panels.length) return;

    var swipers = {};

    function buildSwiper(panel, tries) {
      var el = panel.querySelector('[data-et-bs-swiper]');
      if (!el) return;
      var idx = panel.getAttribute('data-et-panel');
      if (swipers[idx]) { swipers[idx].update(); return; }
      if (typeof window.Swiper !== 'function') {
        if ((tries || 0) > 300) return;
        setTimeout(function () { buildSwiper(panel, (tries || 0) + 1); }, 50);
        return;
      }
      swipers[idx] = new window.Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        grabCursor: true
      });
    }

    function activate(idx, doReplay) {
      var url = '';
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-et-tab') === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) { url = t.getAttribute('data-view-more-url') || ''; }
      });

      panels.forEach(function (p) {
        var on = p.getAttribute('data-et-panel') === idx;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });

      viewMores.forEach(function (v) {
        if (url) { v.setAttribute('href', url); v.style.display = ''; }
        else { v.style.display = 'none'; }
      });

      var active = section.querySelector('[data-et-panel="' + idx + '"]');
      if (active) {
        buildSwiper(active, 0);
        // The panel just became visible — recalc sizes once layout settles.
        requestAnimationFrame(function () {
          if (swipers[idx] && typeof swipers[idx].update === 'function') {
            swipers[idx].update();
          }
        });
        if (doReplay && window.EtReveal && typeof window.EtReveal.replay === 'function') {
          window.EtReveal.replay(active);
        }
      }
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.getAttribute('data-et-tab'), true);
      });
    });

    var initial = section.querySelector('[data-et-tab].is-active') || tabs[0];
    activate(initial.getAttribute('data-et-tab'), false);
  }

  function init(scope) {
    (scope || document).querySelectorAll(SEL).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) init(e.target);
  });
})();
